import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import {
	TOURIST_SECTIONS,
	planStepByRoute,
	planNextStep,
	planPrevStep,
} from '../../data/touristNavigation';
import '../../styles/tourist-nav.scss';

function TouristWayfinder({ section, currentLabel, planStepId }) {
	const location = useLocation();
	const activePlan = planStepId || (section === 'plan' ? planStepByRoute(location.pathname) : null);
	const activeId = activePlan && (typeof activePlan === 'string' ? activePlan : activePlan.id);
	const resolvedId = typeof activePlan === 'object' && activePlan ? activePlan.id : activeId;
	const next = resolvedId ? planNextStep(resolvedId) : null;
	const prev = resolvedId ? planPrevStep(resolvedId) : null;
	const sectionMeta = TOURIST_SECTIONS[section] || TOURIST_SECTIONS.home;

	return (
		<div className="tourist-nav tourist-nav--sub">
			<div className="tourist-nav__breadcrumb container">
				<Link to="/" className="tourist-nav__crumb">Home</Link>
				<span className="tourist-nav__sep" aria-hidden="true">/</span>
				<Link to={sectionMeta.route} className="tourist-nav__crumb">{sectionMeta.label}</Link>
				{currentLabel && (
					<>
						<span className="tourist-nav__sep" aria-hidden="true">/</span>
						<span className="tourist-nav__here" aria-current="page">{currentLabel}</span>
					</>
				)}
			</div>

			{(prev || next || section === 'places') && (
				<div className="tourist-nav__linear container">
					{section === 'places' ? (
						<Link to="/#places" className="tourist-nav__prev">← All places</Link>
					) : prev ? (
						<Link to={prev.route} className="tourist-nav__prev">← {prev.label}</Link>
					) : (
						<Link to="/#plan" className="tourist-nav__prev">← All plan topics</Link>
					)}
					{next && (
						<Link to={next.route} className="tourist-nav__next">Next: {next.label} →</Link>
					)}
				</div>
			)}
		</div>
	);
}

export default TouristWayfinder;
